/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { activateBrand } from '../fn/harvest-metric-target/activate-brand';
import { ActivateBrand$Params } from '../fn/harvest-metric-target/activate-brand';
import { cloneTargets } from '../fn/harvest-metric-target/clone-targets';
import { CloneTargets$Params } from '../fn/harvest-metric-target/clone-targets';
import { cloneTargetsAndUpdate } from '../fn/harvest-metric-target/clone-targets-and-update';
import { CloneTargetsAndUpdate$Params } from '../fn/harvest-metric-target/clone-targets-and-update';
import { deleteTargets } from '../fn/harvest-metric-target/delete-targets';
import { DeleteTargets$Params } from '../fn/harvest-metric-target/delete-targets';
import { getTargets } from '../fn/harvest-metric-target/get-targets';
import { GetTargets$Params } from '../fn/harvest-metric-target/get-targets';
import { getTargetValues } from '../fn/harvest-metric-target/get-target-values';
import { GetTargetValues$Params } from '../fn/harvest-metric-target/get-target-values';
import { HarvestMetricTargetBrandEntry } from '../models/harvest-metric-target-brand-entry';
import { HarvestMetricTargetDto } from '../models/harvest-metric-target-dto';
import { HarvestMetricTargetUpdateResponse } from '../models/harvest-metric-target-update-response';
import { HarvestTargetResponse } from '../models/harvest-target-response';
import { listBrandsTargets } from '../fn/harvest-metric-target/list-brands-targets';
import { ListBrandsTargets$Params } from '../fn/harvest-metric-target/list-brands-targets';
import { renameBrand } from '../fn/harvest-metric-target/rename-brand';
import { RenameBrand$Params } from '../fn/harvest-metric-target/rename-brand';
import { updateTargets } from '../fn/harvest-metric-target/update-targets';
import { UpdateTargets$Params } from '../fn/harvest-metric-target/update-targets';

@Injectable({ providedIn: 'root' })
export class HarvestMetricTargetService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTargets()` */
  static readonly GetTargetsPath = '/api/metric-target';

  /**
   * Get Targets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTargets()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTargets$Response(params: GetTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestTargetResponse>> {
    return getTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Targets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTargets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTargets(params: GetTargets$Params, context?: HttpContext): Observable<HarvestTargetResponse> {
    return this.getTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestTargetResponse>): HarvestTargetResponse => r.body)
    );
  }

  /** Path part for operation `activateBrand()` */
  static readonly ActivateBrandPath = '/api/metric-target/activate';

  /**
   * Activate Brand.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `activateBrand()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  activateBrand$Response(params: ActivateBrand$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return activateBrand(this.http, this.rootUrl, params, context);
  }

  /**
   * Activate Brand.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `activateBrand$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  activateBrand(params: ActivateBrand$Params, context?: HttpContext): Observable<void> {
    return this.activateBrand$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `cloneTargets()` */
  static readonly CloneTargetsPath = '/api/metric-target/clone';

  /**
   * Clone Targets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cloneTargets()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cloneTargets$Response(params: CloneTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestMetricTargetDto>> {
    return cloneTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * Clone Targets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cloneTargets$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cloneTargets(params: CloneTargets$Params, context?: HttpContext): Observable<HarvestMetricTargetDto> {
    return this.cloneTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestMetricTargetDto>): HarvestMetricTargetDto => r.body)
    );
  }

  /** Path part for operation `cloneTargetsAndUpdate()` */
  static readonly CloneTargetsAndUpdatePath = '/api/metric-target/clone-and-update';

  /**
   * Clone Targets And Update.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cloneTargetsAndUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cloneTargetsAndUpdate$Response(params: CloneTargetsAndUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestMetricTargetUpdateResponse>> {
    return cloneTargetsAndUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Clone Targets And Update.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cloneTargetsAndUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cloneTargetsAndUpdate(params: CloneTargetsAndUpdate$Params, context?: HttpContext): Observable<HarvestMetricTargetUpdateResponse> {
    return this.cloneTargetsAndUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestMetricTargetUpdateResponse>): HarvestMetricTargetUpdateResponse => r.body)
    );
  }

  /** Path part for operation `deleteTargets()` */
  static readonly DeleteTargetsPath = '/api/metric-target/delete';

  /**
   * Delete Targets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTargets()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTargets$Response(params: DeleteTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Targets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTargets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTargets(params: DeleteTargets$Params, context?: HttpContext): Observable<void> {
    return this.deleteTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTargetValues()` */
  static readonly GetTargetValuesPath = '/api/metric-target/get';

  /**
   * Get Target Values.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTargetValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTargetValues$Response(params: GetTargetValues$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestMetricTargetDto>> {
    return getTargetValues(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Target Values.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTargetValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTargetValues(params: GetTargetValues$Params, context?: HttpContext): Observable<HarvestMetricTargetDto> {
    return this.getTargetValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestMetricTargetDto>): HarvestMetricTargetDto => r.body)
    );
  }

  /** Path part for operation `listBrandsTargets()` */
  static readonly ListBrandsTargetsPath = '/api/metric-target/list';

  /**
   * List Brands Targets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listBrandsTargets()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBrandsTargets$Response(params?: ListBrandsTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HarvestMetricTargetBrandEntry>>> {
    return listBrandsTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * List Brands Targets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listBrandsTargets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBrandsTargets(params?: ListBrandsTargets$Params, context?: HttpContext): Observable<Array<HarvestMetricTargetBrandEntry>> {
    return this.listBrandsTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<HarvestMetricTargetBrandEntry>>): Array<HarvestMetricTargetBrandEntry> => r.body)
    );
  }

  /** Path part for operation `renameBrand()` */
  static readonly RenameBrandPath = '/api/metric-target/rename';

  /**
   * Rename Brand.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `renameBrand()` instead.
   *
   * This method doesn't expect any request body.
   */
  renameBrand$Response(params?: RenameBrand$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return renameBrand(this.http, this.rootUrl, params, context);
  }

  /**
   * Rename Brand.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `renameBrand$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  renameBrand(params?: RenameBrand$Params, context?: HttpContext): Observable<void> {
    return this.renameBrand$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateTargets()` */
  static readonly UpdateTargetsPath = '/api/metric-target/update/{brandName}/{harvestSex}';

  /**
   * Update Targets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTargets()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTargets$Response(params: UpdateTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestMetricTargetUpdateResponse>> {
    return updateTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Targets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTargets$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTargets(params: UpdateTargets$Params, context?: HttpContext): Observable<HarvestMetricTargetUpdateResponse> {
    return this.updateTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<HarvestMetricTargetUpdateResponse>): HarvestMetricTargetUpdateResponse => r.body)
    );
  }

}
